// eslint-disable-next-line
import ImgBg from "./../../../assets/hero/hero.jpg";

export default function SearchBar() {
    return {
        restrict: "E",
        scope: {
            redirectToSearch: "=",
        },
        //replace: true,
        template: require("./template.html"),
        transclude: true,
        controller: function (
            $scope,
            $timeout,
            $q,
            hotkeys,
            keyboardNavFactory,
            houseService,
            siteService,
            searchBarFactory,
            $rootScope,
            $filter,
            moment,
            Scroll
        ) {
            // when you bind it to the controller's scope, it will automatically unbind
            // the hotkey when the scope is destroyed (due to data-ng-if or something that changes the DOM)
            hotkeys
                .bindTo($scope)
                .add({
                    combo: "down",
                    description: "Search bar - navigate dropdown (when active)",
                    allowIn: ["INPUT"],
                    callback: function (event) {
                        keyboardNavFactory.doActionOnActiveDropdown(event, 1);
                    },
                })
                // you can chain these methods for ease of use:
                .add({
                    combo: "up",
                    description: "Search bar - navigate dropdown (when active)",
                    allowIn: ["INPUT"],
                    callback: function (event) {
                        keyboardNavFactory.doActionOnActiveDropdown(event, -1);
                    },
                })

                .add({
                    combo: "right",
                    description: "Search bar - navigate dropdown (when active)",
                    callback: function (event) {
                        keyboardNavFactory.doActionOnActiveDropdown(
                            event,
                            null
                        );
                    },
                })

                .add({
                    combo: "left",
                    description: "Search bar - navigate dropdown (when active)",
                    callback: function (event) {
                        keyboardNavFactory.doActionOnActiveDropdown(
                            event,
                            null
                        );
                    },
                })

                .add({
                    combo: "escape",
                    description: "Search bar - navigate dropdown (when active)",

                    callback: function () {
                        if (
                            searchBarFactory.oSearchActive &&
                            searchBarFactory.oSearchActive.name !=
                                "search-calender"
                        ) {
                            console.log("pressed escape");
                            searchBarFactory.deactivateDropdown(
                                searchBarFactory.oSearchActive
                            );
                            searchBarFactory.focusCloseBtn(
                                searchBarFactory.oSearchActive
                            );
                        }
                    },
                });

            $scope.searchBarFields = searchBarFactory.searchBarFields;

            /*******************************
             * Event listeners
             *******************************/

            var activateDropdownEventListener = $scope.$on(
                "activate-searchbar-dropdown-broadcast",
                function ($event, aSearchbarInputIndex) {
                    //find searchInput (category,type,calender or time ) in searchBar we want to open -> find by index in searchBarFactory.oSearchInputIndex
                    var searchInput =
                        searchBarFactory.aSearchInputs[aSearchbarInputIndex];

                    $scope.activateDropdown(searchInput);
                }
            );
            $scope.$on("$destroy", activateDropdownEventListener);

            var syncSearchbarEventListener = $scope.$on(
                "sync-searchbar-broadcast",
                function (event, item) {
                    if (item.type == null) {
                        console.warn(
                            "sync-search -> House Type is not defined"
                        );
                    }

                    $scope.syncSearchBar(item);
                }
            );
            $scope.$on("$destroy", syncSearchbarEventListener);

            /*******************************
             * DEBUGGING
             *******************************/

            var debugEvents = false;

            $scope.debugging = false;
            $scope.debugFormSearchBar = false;
            $scope.debugCategory = false;
            $scope.debugType = false;
            $scope.debugCalender = false;
            $scope.debugTime = false;
            $scope.debugMisc = false;

            /*******************************
             * Bind Service with scope vars
             *******************************/

            // Set filter ( binding shorthand )
            $scope.searchFilter = houseService.searchFilter;
            $scope.headerHeight = siteService.headerHeight;

            $scope.calenderFilter = houseService.calenderFilter;

            /*************************************
             * Get resources
             *************************************/
            if (houseService.firstLoad) {
                /*****************************************
                 *  Input Object Setup -  searchBarFactory
                 *****************************************/

                // instantiates the objects function
                searchBarFactory.createSearchObjects();

                // put each search input object in $scope

                $scope.oSearchCategory = searchBarFactory.oSearchCategory =
                    searchBarFactory.get_oSearchCategory();
                $scope.oSearchType = searchBarFactory.oSearchType =
                    searchBarFactory.get_oSearchType();
                $scope.oSearchCalender = searchBarFactory.oSearchCalender =
                    searchBarFactory.get_oSearchCalender();
                $scope.oSearchTime = searchBarFactory.oSearchTime =
                    searchBarFactory.get_oSearchTime();

                // on first load objects we will get the necessary resources from the Web API!
                $q.all({
                    houseTypesActivityMapping:
                        houseService.getLocationsActivityMapping(),
                    housecategories: houseService.getActivitiesHierachical(),
                    housetypes: houseService.getLocations(),
                }).then((res) => {
                    $scope.houseTypesActivityMapping =
                        houseService.houseTypesActivityMapping =
                            res.houseTypesActivityMapping;

                    $scope.housecategories =
                        $scope.oSearchCategory.items =
                        houseService.housecategories =
                            res.housecategories;

                    $scope.housetypes =
                        $scope.oSearchType.items =
                        houseService.housetypes =
                            res.housetypes;

                    $scope.oSearchCategory.defaultItem =
                        houseService.searchFilter.getDefaultFromHouseArray(
                            res.housecategories,
                            0
                        );

                    $scope.PreLoadUserSelections(
                        $scope.oSearchCategory,
                        houseService.searchFilter.houseCategory
                    );

                    //set default Type var
                    $scope.oSearchType.defaultItem = $filter("filter")(
                        $scope.housetypes,
                        function (t) {
                            return t.ID <= 0;
                        }
                    )[0];

                    $scope.PreLoadUserSelections(
                        $scope.oSearchType,
                        houseService.searchFilter.houseType
                    );
                });

                // Get houseCategories ( activities ) - flat
                houseService
                    .getActivities()
                    .then(function (housecategorieslight) {
                        $scope.housecategorieslight =
                            $scope.oSearchCategory.housecategorieslight =
                            houseService.housecategorieslight =
                                housecategorieslight;
                    });
            } else {
                // When it's not the first Load
                // console.log('skipping Web API ');

                // put each search input object in $scope
                // searchBarFactory.theHouseCategory
                $scope.oSearchCategory = searchBarFactory.oSearchCategory =
                    searchBarFactory.get_oSearchCategory();
                $scope.oSearchType = searchBarFactory.oSearchType =
                    searchBarFactory.get_oSearchType();
                $scope.oSearchCalender = searchBarFactory.oSearchCalender =
                    searchBarFactory.get_oSearchCalender();
                $scope.oSearchTime = searchBarFactory.oSearchTime =
                    searchBarFactory.get_oSearchTime();

                // Rebind scope from service
                $scope.housecategories = houseService.housecategories;
                $scope.housecategorieslight = houseService.housecategorieslight;

                $scope.housetypes = houseService.housetypes;

                $scope.houseTypesActivityMapping =
                    houseService.houseTypesActivityMapping;
            }

            $scope.PreLoadUserSelections = function (
                newHouse,
                houseFromService
            ) {
                var tmp_id = 0;

                if (houseFromService.hasOwnProperty("CategoryID")) {
                    tmp_id = houseFromService.CategoryID;
                }

                if (houseFromService.hasOwnProperty("ID")) {
                    tmp_id = houseFromService.ID;
                }

                if (tmp_id == 0) {
                    // could be empty

                    newHouse.suggested = newHouse.defaultItem;
                    newHouse.buffer = newHouse.defaultItem;
                } else {
                    newHouse.suggested = houseFromService;
                    newHouse.buffer = houseFromService;
                }
            };

            /************* Scope Up ********************/
            /*******************************
             * Input vars
             *******************************/

            // init input vars. update from service

            if (houseService.firstLoad == "asdfasd") {
                // only initialize the service Once!

                /*******************************
                 * Calender vars - On load
                 *******************************/
                $scope.oSearchCalender.userSelected.date =
                    houseService.calenderFilter.startDate();

                // Update the searchFilter - date

                houseService.searchFilter.startDateDayOfWeek = moment(
                    houseService.calenderFilter.startDate(),
                    "DD-MM-YYYY"
                ).toDate();

                // Update the searchFilter - time
                // houseService.searchFilter.startTime = houseService.calenderFilter.startTime();
                // houseService.searchFilter.endTime =  houseService.calenderFilter.endTime();

                // Update Selected / Available
                //houseService.calenderFilter.selectedDate = houseService.calenderFilter.startDate();
                houseService.calenderFilter.selectedStartTime =
                    houseService.searchFilter.startTime; //houseService.calenderFilter.startTime();
                houseService.calenderFilter.selectedEndTime =
                    houseService.searchFilter.endTime; //houseService.calenderFilter.endTime();

                houseService.calenderFilter.availableStartHours =
                    houseService.calenderFilter.startHours();
                houseService.calenderFilter.availableEndHours =
                    houseService.calenderFilter.endHours();
            }

            if (houseService.firstLoad == true) {
                //console.log('First Load');

                // FIRST LOAD - Must be called Last in init Phase
                houseService.firstLoad = false;
            } else {
                //console.log('NOT first Load');
            }

            /************* END INIT PHASE ***********************/

            $scope.deactivateDropdown = function (oSearchInput) {
                searchBarFactory.deactivateDropdown(oSearchInput);
            };

            $scope.deactivateAllDropdowns = function () {
                searchBarFactory.deactivateAllDropdowns();
            };

            /*********************************************
             * INPUT SUGGESTIONS
             *********************************************/

            $scope.suggestItem = function (oSearchInput) {
                if (debugEvents) {
                    console.log("suggestItem");
                }

                if (oSearchInput.filteredItems.filterInUse.length > 0) {
                    // Always suggest the first (top) elem in list
                    oSearchInput = searchBarFactory.setSuggestedItem(
                        oSearchInput,
                        oSearchInput.filteredItems.filterInUse[0]
                    );
                }
            };

            /************************************
             * USER -> USER SELECT DROPDOWN VALUE
             ***********************************/

            $scope.onChangeInput = function (userInput, searchInput) {
                if (searchInput.activeDropdown) {
                    $timeout(function () {
                        $scope.$apply(function () {
                            // trigger digest cycle

                            $scope.suggestItem(searchInput);

                            // if empty set to false - otherwise display the result
                            searchInput.filter = angular.copy(userInput); // ( userInput == "") ? false : angular.copy( userInput );

                            // no more search results in filter ?
                            if (
                                searchInput.filteredItems.filterInUse.length ==
                                0
                            ) {
                                searchInput.noResults = true;

                                // set default item as suggested and buffer
                                searchInput.suggested = angular.copy(
                                    searchInput.defaultItem
                                );

                                searchInput.buffer = angular.copy(
                                    searchInput.defaultItem
                                );
                            } else {
                                searchInput.noResults = false;
                            }
                        });
                    }, 100);
                } else {
                    searchInput.input = angular.copy(
                        searchInput.suggested.Name
                    );
                }
            };

            /*******************************
             * RESET - search house object
             *******************************/

            /************* reset all ***********************/
            $scope.resetSearch = function () {
                searchBarFactory.resetSearch();
            };

            /************* reset single input ***********************/
            $scope.resetsearchInput = function (searchInput, resetAll) {
                searchBarFactory.resetsearchInput(searchInput, resetAll);
            };

            $scope.refillInputPlaceholders = function () {
                searchBarFactory.refillInputPlaceholders();
            };

            // On load
            $scope.refillInputPlaceholders();

            /*******************************
             * USER -> Activate Dropdown
             *******************************/

            $scope.activateDropdown = function (oSearchInput) {
                // Take Focus on input

                $scope.disableUITooltip_preventWideSearch();
                searchBarFactory.activateDropdown(oSearchInput);
            };

            $scope.toggleMobileKeyboard = function (searchInput) {
                $scope.scrollToElem(
                    searchInput.name,
                    siteService.headerHeight + 15
                );

                if (!searchInput.keyboardActive) {
                    $("#" + searchInput.name + " input.form-control").focus();

                    searchInput.keyboardActive = true;
                } else {
                    searchInput.keyboardActive = false;

                    if (searchInput.filter != "") {
                        //$scope.resetsearchInput( searchInput, false );
                    }
                }
            };

            /**********************************
             * AUTO SCROLL HANDLER
             *********************************/

            $scope.scrollToElem = function (elemID, offset) {
                Scroll.to(elemID, offset);
            };

            /**********************************
             * USER ->  Select Category / Type
             *********************************/

            $scope.activatePossibleItems = function (selectedItem, searchType) {
                searchBarFactory.activatePossibleItems(
                    selectedItem,
                    searchType
                );
            };

            // Select Item
            $scope.selectItem = function (selectedItem, oSearchInput) {
                searchBarFactory.selectItem(selectedItem, oSearchInput);
            };

            /***************************************
             * Tree based - Dropdown Functionality
             **************************************/

            $scope.showSubMenu = function (CategoryID, oSearchInput) {
                searchBarFactory.showSubMenu(
                    $scope.housecategories,
                    CategoryID,
                    oSearchInput
                );
            };

            $scope.backToRootMenu = function (oSearchInput) {
                searchBarFactory.backToRootMenu(oSearchInput);
            };

            /*******************************
             * Searchbar Overlay
             *******************************/

            $scope.overlaySwitch = function () {
                // if(debugEvents){ console.log('overlaySwitch') };

                if (
                    $scope.oSearchCategory.activeDropdown ||
                    $scope.oSearchType.activeDropdown ||
                    $scope.oSearchTime.activeDropdown ||
                    $scope.oSearchCalender.activeDropdown
                ) {
                    return true;
                }
            };

            $scope.resetAndCloseDropdown = function (oSearchInput) {
                searchBarFactory.resetAndCloseDropdown(oSearchInput);
            };

            $scope.syncSearchBar = function (house) {
                if (house.type == "activity") {
                    // aka house activity/category
                    $scope.selectItem(house, $scope.oSearchCategory);
                }
                if (house.type == "location") {
                    // aka house place / type
                    $scope.selectItem(house, $scope.oSearchType);
                }
            };

            // Close all dropdown on route change
            var routeChangeSuccessEventListerner = $rootScope.$on(
                "$routeChangeSuccess",
                function () {
                    //avail param : event, currentRoute
                    $scope.deactivateAllDropdowns();
                }
            );

            $scope.$on("$destroy", routeChangeSuccessEventListerner);

            /*******************************
             *  SEARCH BUTTON
             *******************************/
            $scope.searchBroadcast = function ($event) {
                $event.preventDefault();
                //avail params :  oSearchCategory, oSearchType, oSearchCalender, oSearchTime, searchFilter

                if (
                    $scope.oSearchCategory.buffer.CategoryID == 0 &&
                    $scope.oSearchType.buffer.ID == -1
                ) {
                    $scope.activateUITooltip_preventWideSearch();
                } else {
                    searchBarFactory.searchBroadcast();

                    if ($scope.redirectToSearch) {
                        // UrlFactory.route();
                    }
                }
            };

            /**
             *
             * Aria Label for search button
             */
            $scope.searchBtnAriaLabel = function () {
                let ariaLabel = "";

                if (
                    $scope.oSearchCategory.buffer.CategoryID == 0 &&
                    $scope.oSearchType.buffer.ID == -1
                ) {
                    ariaLabel =
                        "For at lave en søgning skal du først vælge aktivitet eller sted";
                } else {
                    let date = $scope.calenderFilter.selectedDate
                        ? $scope.calenderFilter.selectedDate
                        : houseService.searchFilter.startDate;

                    ariaLabel = `Foretag søgning på aktivitet : ${$scope.oSearchCategory.buffer.Name} på sted : ${$scope.oSearchType.buffer.Name} den : ${date}`;
                }

                return ariaLabel;
            };

            /********************
             * UITooltip prevent Wide Search
             * prevent a user from searching everything, which takes to long
             */

            var UIToolitipEventListener = $rootScope.$on(
                "show-UI-Tooltip-preventWideSearch",
                function () {
                    //avail param : event
                    $scope.activateUITooltip_preventWideSearch();
                }
            );

            $scope.$on("$destroy", UIToolitipEventListener);

            $scope.showUITooltip_preventWideSearch = false;

            $scope.toggleUITooltip_preventWideSearch = function () {
                $scope.showUITooltip_preventWideSearch =
                    !$scope.showUITooltip_preventWideSearch;
            };

            $scope.disableUITooltip_preventWideSearch = function () {
                $scope.showUITooltip_preventWideSearch = false;
            };

            $scope.activateUITooltip_preventWideSearch = function () {
                // Set focus to search bar
                $("#search-fields").focus();
                $scope.showUITooltip_preventWideSearch = true;
            };
        },
    };
}
